<template>
    <div>
        <v-row>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.category"
                    :label="categories.label"
                    :items="categories.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">

                <v-menu
                    ref="menu"
                    v-model="datePkr"
                    :close-on-content-click="false"
                    :return-value.sync="activeFilters.creation"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedDate"
                            :label="creation.label"
                            clearable
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="activeFilters.creation"
                        no-title
                        range
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="datePkr = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="teal lighten-2"
                            @click="dateChange(activeFilters.creation)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.existence"
                    :label="existence.label"
                    :items="existence.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.product"
                    :label="products.label"
                    :items="products.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.seller"
                    :label="sellers.label"
                    :items="sellers.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.manufacturer"
                    :label="manufacturers.label"
                    :items="manufacturers.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-center">
                <v-autocomplete
                    v-model="activeFilters.visibility"
                    :label="visibility.label"
                    :items="visibility.valuesData"
                    hide-no-data
                    item-text="name"
                    item-value="id"
                    @change="filterChange"
                    cache-items
                    clearable
                    color="teal lighten-2"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import { FilterService } from '../../services'
import { MixinFiltersGeneral } from "../../mixins";

export default {
    name: "ProductFilters",
    mixins:[ MixinFiltersGeneral ],
    props: [ 'pageType' ],
    data() {
        return {
            activeFilters: {},
            layout:[],
            datePkr: false
        }
    },
    computed: {
        categories() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.category.systemName);
            return filter || {};
        },
        creation() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.creation.systemName);
            return filter || {};
        },
        existence() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.existence.systemName);
            return filter || {};
        },
        manufacturers() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.manufacturer.systemName);
            return filter || {};
        },
        products() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.product.systemName);
            return filter || {};
        },
        sellers() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.seller.systemName);
            return filter || {};
        },
        visibility() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.visibility.systemName);
            return filter || {};
        },
        formattedDate: {
            get() {
                if(Array.isArray(this.activeFilters.creation)) {
                    return this.activeFilters.creation.sort().join(' - ')
                } else {
                    return '';
                }
            },
            set(newVal) {
                this.activeFilters.creation = newVal;
                this.filterChange();
            }
        }
    },
    methods: {
        dateChange(date) {
            this.$refs.menu.save(date);
            this.filterChange();
        },
        getLayout() {
            const params = { pageType: this.pageType }
            this.setFiltersFromUrl();
            FilterService.setAuth(this.$store.getters.token);
            return FilterService.getAdminProductsLayout( params )
                .then(res => {
                    this.layout = res.data;
                })
                .catch(err => {console.log(err)});
        },
        filterChange(){
            this.addFiltersToUrl(this.activeFilters, this.$route);
            this.$emit('filter-change', {...this.activeFilters});
        },
        setFiltersFromUrl(){
            this.activeFilters = this.getFiltersFromUrl();
            this.filterChange();
        }
    },
    created() {
        this.getLayout();
    },
}
</script>

<style scoped>

</style>
